export default {
    'delete-view': 'Eliminar vista',
    'save-view': 'Guardar vista',
    'update-view': 'Actualizar vista',
    accept: 'Aceptar',
    add: 'Añadir',
    advertencia: '¡Advertencia!',
    cancel: 'Cancelar',
    create: 'Crear',
    close: 'Cerrar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    download: 'Descargar',
    edit: 'Editar',
    false: 'No',
    load: 'Cargar',
    new: 'Nuevo',
    no_registers: 'No hay registros que mostrar',
    no: 'No',
    NO: 'No',
    save: 'Guardar',
    send: 'Enviar',
    true: 'Si',
    uploading: 'Subiendo',
    yes: 'Si',
    YES: 'Si',
    validations: {
        mandatory: 'Este campo es obligatorio',
        length: 'Este campo debe tener al menos',
        characters: 'caracteres',
        _mandatory: 'es obligatorio',
        field: 'El campo',
        at_leat: 'debe tener al menos'
    },
    classes: {
        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D'
    }
};
